import React from "react";
import {PiRocket} from "react-icons/pi";
import {Link} from "react-router-dom";
import {IoHome} from "react-icons/io5";
import {CgProfile} from "react-icons/cg";

function Header() {
    return (
        <nav className={"py-3 px-3 bg-white border-bottom  "} style={{fontFamily: "Poppins", zIndex: 99999}}>
            <div className={""}>
                <div className={"row"}>
                    <div className={"col d-flex align-items-center"}>
                        <Link className={"d-flex text-dark text-decoration-none align-items-center p-0"} to={"/"}>
                            <PiRocket size={24}/>
                            <h5 className={"m-0 p-0 ms-1 "}>karakterboost</h5>
                        </Link>
                    </div>

                    <div className={"col d-flex align-content-center justify-content-center"}>
                        <Link to={"/butikk"} className="btn text-dark mx-3">Kurs</Link>
                        <Link to={"/prices"} className="btn text-dark mx-3">Priser</Link>
                        <Link to={"/contact"} className="btn text-dark mx-3">Kontakt</Link>
                        <Link to={"/faq"} className="btn text-dark mx-3">FAQ</Link>
                    </div>

                    <div className={"col p-0"}>
                        <div className="d-flex align-items-center justify-content-end pe-3"
                             style={{fontFamily: "Poppins"}}>

                            <div>
                                <Link to={"/hjem"} className={"text-decoration-none btn btn-secondary text-white me-2"}>
                                    <IoHome className={"me-2"} size={18}/>
                                    Hjem
                                </Link>
                                <Link to={"/user/settings"} className={"text-decoration-none btn p-0  "}>
                                    <CgProfile className={"me-2"} size={28}/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Header;